module.exports = __webpack_public_path__ + "static/media/5.0fa3f04c.gif";